import apiClient from "./apiClient";

export const GetQuestion = async (v) => {
  return apiClient
    .post("option/get", v)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      return error;
    });
};

// To get questions for exam
export const GetExamQuestion = async (v) => {
  return apiClient
    .post("question/get", v)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      return error;
    });
};

// Exam submit
export const SubmitAnswers = async (payload) => {
  try {
    const response = await apiClient.post("option", payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        message: error.response.data || "Request failed",
      };
    } else {
      return {
        success: false,
        status: 0,
        message: error.message || "Network error",
      };
    }
  }
};

// Returns structured error with status code so callers can detect
// token expiry (498) vs actual network failures
export const StartExam = async (v) => {
  try {
    const response = await apiClient.post("exam", v);
    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        message: error.response.data || "Request failed",
      };
    }
    return {
      success: false,
      status: 0,
      message: error.message || "Network error",
    };
  }
};
